import React from 'react';

export const MetricCard = ({ title, value, subtitle, icon: Icon, color = 'primary' }) => {
  const colorClasses = {
    primary: 'text-[hsl(var(--brand-primary))]',
    gain: 'text-[hsl(var(--gain))]',
    loss: 'text-[hsl(var(--loss))]',
    neutral: 'text-[hsl(var(--text-primary))]',
  };

  return (
    <div
      data-testid={`metric-card-${title.toLowerCase().replace(/\s+/g, '-')}`}
      className="bg-white border border-[hsl(var(--border))] rounded-xl p-6 hover:-translate-y-1 hover:shadow-lg transition-all duration-200"
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="text-sm text-[hsl(var(--text-secondary))] mb-2">{title}</div>
          <div className={`text-3xl font-bold font-mono ${colorClasses[color]}`}>
            {value}
          </div>
          {subtitle && (
            <div className="text-xs text-[hsl(var(--text-tertiary))] mt-1">{subtitle}</div>
          )}
        </div>
        {Icon && (
          <div className={`p-3 bg-[hsl(var(--background-secondary))] rounded-lg ${colorClasses[color]}`}>
            <Icon className="w-6 h-6" />
          </div>
        )}
      </div>
    </div>
  );
};